"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _dayjs = _interopRequireDefault(require("dayjs"));
var _default2 = exports.default = {
  props: {
    id: {
      type: String,
      default: "chart1"
    },
    name: {
      type: String,
      default: ""
    },
    dayData: {
      type: String,
      default: (0, _dayjs.default)().format("YYYY-MM-DD")
    },
    nameTip: {
      type: String,
      default: ""
    },
    showTip: {
      type: Boolean,
      default: false
    },
    isLook: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      zoom: '',
      zoomrAtio: ''
    };
  },
  watch: {
    data: function data() {
      this.getLineChart();
    }
  },
  methods: {
    handleLook: function handleLook() {
      this.$emit("look", this.name);
    },
    handleClose: function handleClose() {
      this.$parent.isLook = false;
    },
    getLineChart: function () {
      var _getLineChart = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this = this;
        var lineChart, seriesData, option;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              lineChart = this.$echarts.init(document.getElementById(this.id));
              seriesData = [];
              lineChart.clear();
              option = {
                tooltip: {
                  confine: true,
                  trigger: "axis",
                  backgroundColor: "rgba(255,255,255,1)",
                  extraCssText: "box-shadow:0 0 18px rgba(0,120,234,0.1);color:#000000",
                  textStyle: {
                    fontSize: 24,
                    lineHeight: 30
                  },
                  padding: 15
                },
                legend: {
                  icon: "circle"
                },
                grid: {
                  left: "3%",
                  right: "7%",
                  bottom: "8%",
                  top: "6%",
                  containLabel: true
                },
                xAxis: {
                  type: "category",
                  name: "(h)",
                  splitLine: {
                    show: false
                  },
                  // 去除网格线
                  axisTick: {
                    show: false
                  },
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: "#cfcfcf",
                      width: 1,
                      type: "solid"
                    }
                  },
                  boundaryGap: true,
                  axisLabel: {
                    show: true,
                    interval: "auto",
                    rotate: 0,
                    formatter: function formatter(params) {
                      var newParamsName = "";
                      var paramsNameNumber = params.length;
                      var provideNumber = 10; // 一行显示几个字
                      var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                      if (paramsNameNumber > provideNumber) {
                        for (var p = 0; p < rowNumber; p++) {
                          var tempStr = "";
                          var start = p * provideNumber;
                          var end = start + provideNumber;
                          if (p === rowNumber - 1) {
                            tempStr = params.substring(start, paramsNameNumber);
                          } else {
                            tempStr = params.substring(start, end) + "\n";
                          }
                          newParamsName += tempStr;
                        }
                      } else {
                        newParamsName = params;
                      }
                      return newParamsName;
                    },
                    textStyle: {
                      color: "#999999" // 文字颜色
                    }
                  }
                  // data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                },
                yAxis: {
                  type: "value",
                  splitLine: {
                    show: false
                  },
                  axisTick: {
                    show: false
                  },
                  // axisLine: { // y轴
                  //   show: false
                  // }
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: "#cfcfcf",
                      width: 1,
                      type: "solid"
                    }
                  }
                },
                series: seriesData
              };
              _context.next = 6;
              return this.data.map(function (el, i) {
                switch (_this.name) {
                  case "供冷分布":
                    {
                      var xData = [];
                      var fgpColor = ["#333333", "#37D600", "#EE1538", "#e5e5e5"];
                      el.data.forEach(function (item) {
                        // 当日是否超过系统时间
                        var isExpiredDay = new Date(_this.$parent.dayData + " 23:59") > new Date();
                        var isExpired = Number(item[0].slice(0, 2)) >= new Date().getHours() && _this.$parent.isShow;
                        xData.push({
                          value: item[0],
                          textStyle: {
                            color: isExpired && isExpiredDay ? fgpColor[3] : fgpColor[item[2] - 1]
                          }
                        });
                      });
                      option.color = ["#1a3564", "#538332", "#2a76b7", "#ffc100"];
                      option.xAxis.axisLabel.rotate = 90;
                      option.xAxis.data = xData;
                      option.tooltip.formatter = function (params) {
                        var str = params[0].axisValueLabel;
                        params.forEach(function (item) {
                          str += "<br />".concat(item.marker).concat(item.seriesName, ": ").concat(item.data, "kwh");
                        });
                        return "".concat(str);
                      };
                      seriesData.push({
                        name: el.fieldMeaning,
                        type: "bar",
                        emphasis: {
                          focus: "series"
                        },
                        data: el.data.map(function (item) {
                          // 当日是否超过系统时间
                          var isExpired = null;
                          if ((0, _dayjs.default)(_this.dayData).isBefore((0, _dayjs.default)(new Date()))) {
                            isExpired = false;
                          } else {
                            isExpired = Number(item[0].slice(0, 2)) > new Date().getHours() + 1;
                          }
                          return !isExpired ? item[1] : 0;
                        })
                      });
                    }
                    break;
                  case "系统每小时耗电量":
                    {
                      var xData2 = [];
                      var fgpColor2 = ["#333333", "#37D600", "#EE1538", "#e5e5e5"];
                      el.data.forEach(function (item) {
                        // 当日是否超过系统时间
                        var isExpiredDay = new Date(_this.$parent.dayData + " 23:59") > new Date();
                        var isExpired = Number(item[0].slice(0, 2)) >= new Date().getHours() && _this.$parent.isShow;
                        xData2.push({
                          value: item[0],
                          textStyle: {
                            color: isExpiredDay && isExpired ? fgpColor2[3] : fgpColor2[item[2] - 1]
                          }
                        });
                      });
                      option.color = ["#6EB1FE"];
                      option.xAxis.axisLabel.rotate = 90;
                      option.xAxis.data = xData2;
                      option.tooltip.formatter = function (params) {
                        var str = params[0].axisValueLabel;
                        params.forEach(function (item) {
                          str += "<br />".concat(item.marker).concat(item.seriesName, ": ").concat(item.data, "kwh");
                        });
                        return "".concat(str);
                        // return null
                      };
                      seriesData.push({
                        name: el.fieldMeaning,
                        type: "bar",
                        emphasis: {
                          focus: "series"
                        },
                        data: el.data.map(function (item) {
                          // 当日是否超过系统时间
                          var isExpired = null;
                          if ((0, _dayjs.default)(_this.dayData).isBefore((0, _dayjs.default)(new Date()))) {
                            isExpired = false;
                          } else {
                            isExpired = Number(item[0].slice(0, 2)) > new Date().getHours() + 1;
                          }
                          return !isExpired ? item[1] : 0;
                        })
                      });
                    }
                    break;
                  case "蓄冷槽冷量":
                    option.color = ["#3e89e7", "#fb8c3b"];
                    option.tooltip.formatter = function (params) {
                      var str = params[0].axisValueLabel;
                      params.forEach(function (item) {
                        str += "<br />".concat(item.marker).concat(item.seriesName, ": ").concat(item.data[1]).concat(item.data[2]);
                      });
                      return "".concat(str);
                    };
                    seriesData.push({
                      type: "line",
                      name: el.fieldMeaning,
                      // symbol: 'circle',
                      showSymbol: false,
                      data: el.data,
                      dimensions: [el.company // 如果此维度不想给出定义，则使用 null 即可
                      ],
                      smooth: true,
                      markPoint: {
                        symbol: "circle",
                        symbolSize: 10,
                        label: {
                          fontSize: 16
                        },
                        data: [{
                          type: "max",
                          name: "最大值",
                          label: {
                            position: "top",
                            formatter: "max: {@score}",
                            color: "#000"
                          },
                          itemStyle: {
                            color: "#fff",
                            borderColor: "#4496fe"
                          }
                        }, {
                          type: "min",
                          name: "最小值",
                          label: {
                            position: "bottom",
                            formatter: "min: {@score}",
                            color: "#000"
                          },
                          itemStyle: {
                            color: "#fff",
                            borderColor: "#4496fe"
                          }
                        }]
                      }
                    });
                    break;
                  default:
                    option.color = ["#3e89e7", "#fb8c3b", "#63be65", "#d9c32b"];
                    option.tooltip.formatter = function (params) {
                      var str = params[0].axisValueLabel;
                      params.forEach(function (item) {
                        str += "<br />".concat(item.marker).concat(item.seriesName, ": ").concat(item.data[1]).concat(item.data[2]);
                      });
                      return "".concat(str);
                    };
                    seriesData.push({
                      type: "line",
                      name: el.fieldMeaning,
                      // symbol: 'circle',
                      showSymbol: false,
                      data: el.data,
                      dimensions: [el.company // 如果此维度不想给出定义，则使用 null 即可
                      ],
                      smooth: true
                    });
                    break;
                }
              });
            case 6:
              lineChart.setOption(option);
              this.$nextTick(function () {
                _this.zoom = document.body.style.zoom;
                _this.zoomrAtio = (1 / document.body.style.zoom).toFixed(2);
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getLineChart() {
        return _getLineChart.apply(this, arguments);
      }
      return getLineChart;
    }()
  }
};